import React, { useEffect, useState } from 'react';
import TimerText from './TimerText';
import './CircularTherapyTimer.css';

const CircularTherapyTimer = ({ 
  currentSeconds = 0, 
  goalSeconds = 720, 
  variant = 'default',
  onOpenFullscreen = null 
}) => {
  const [animatedSeconds, setAnimatedSeconds] = useState(currentSeconds);

  // Interpolation fluide
  useEffect(() => {
    const duration = 400; // ms
    const start = animatedSeconds;
    const end = currentSeconds;
    const startTime = performance.now();

    const step = (now) => {
      const t = Math.min(1, (now - startTime) / duration);
      // easing cubic-bezier approx
      const eased = t * t * (3 - 2 * t);
      const value = start + (end - start) * eased;
      setAnimatedSeconds(value);
      if (t < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }, [currentSeconds]);

  // Couleurs par variant
  const colorByVariant = {
    sleep: '#9F86FF',
    chill: '#4DA2FF',
    nature: '#4BB5A8',
    pulse: '#56E5FF',
    breathing: '#5FE3D0',
    classical: '#FFC857',
    default: '#9F86FF'
  };

  const progressColor = colorByVariant[variant] || colorByVariant.default;
  const goalReached = goalSeconds > 0 && currentSeconds >= goalSeconds;
  const effectiveColor = goalReached ? '#4BB5A8' : progressColor;

  // Calcul progression
  const pct = goalSeconds > 0 ? Math.min(1, animatedSeconds / goalSeconds) : 0;
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const dash = circumference * pct;

  return (
    <div 
      className="therapy-timer-container" 
      onClick={() => onOpenFullscreen && onOpenFullscreen()}
    >
      {/* Halo breathing glow */}
      <div className="therapy-timer-glow"></div>

      {/* Goal reached burst */}
      {goalReached && <div className="timer-goal-burst"></div>}

      {/* SVG Circle */}
      <svg 
        className="therapy-timer-svg"
        width="160" 
        height="160" 
        viewBox="0 0 160 160"
      >
        <defs>
          <linearGradient id="hearenWaveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(255,255,255,0.0)" />
            <stop offset="50%" stopColor="rgba(255,255,255,0.3)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0.0)" />
          </linearGradient>
        </defs>

        {/* Background circle */}
        <circle
          className="timer-bg"
          cx="80" 
          cy="80" 
          r={radius}
          stroke="rgba(255,255,255,0.10)"
          strokeWidth="8"
          fill="none"
        />

        {/* Wave effect */}
        <circle
          cx="80" 
          cy="80" 
          r={radius}
          stroke="url(#hearenWaveGradient)"
          strokeWidth="8"
          fill="none"
          strokeDasharray="10 20"
          strokeLinecap="round"
          style={{
            transformOrigin: 'center',
            transform: 'rotate(-90deg)',
            animation: 'hearenWave 8s linear infinite',
            opacity: 0.4
          }}
        />

        {/* Progress circle */}
        <circle
          cx="80" 
          cy="80" 
          r={radius}
          stroke={effectiveColor}
          strokeWidth="8"
          fill="none"
          strokeDasharray={`${dash} ${circumference - dash}`}
          strokeLinecap="round"
          style={{
            transformOrigin: 'center',
            transform: 'rotate(-90deg)',
            transition: 'stroke 0.3s ease-out'
          }}
        />
      </svg>

      {/* Timer Text */}
      <TimerText
        currentSeconds={Math.floor(animatedSeconds)}
        goalSeconds={goalSeconds}
        goalReached={goalReached}
      />
    </div>
  );
};

export default CircularTherapyTimer;
